'use client'
import { useMemo } from 'react'
import { findBreadcrumb } from '@/services/domain/pages/PageTreeService'
import { useHelpPages } from './useHelpPages'

/** Trilha da página do CMS (da categoria raiz até a página do slug), a partir da lista de páginas ativas. */
export function usePageBreadcrumb(slug: string) {
    const { list } = useHelpPages()
    return useMemo(() => findBreadcrumb(list, slug), [list, slug])
}
